import styled, { css } from "styled-components/native";
import React from "react";
import { View } from "@gluestack-ui/themed";
import { DefaultTheme } from "styled-components/native";

type ShadowContainerProps = {
  children: React.ReactNode;
  softShadow?: string;
  paddingHorizontal?: string;
  backgroundColor?: string;
  borderRadius?: string;
  padding?: string;
  marginLeft?: string;
  marginRight?: string;
  marginBottom?: string;
  marginTop?: string;
  justifyContent?: string;
  width?: string;
  maxWidth?: string;
  flexDirection?: string;
  alignItems?: string;
};

const ShadowContainer = ({
  children,
  softShadow,
  paddingHorizontal,
  backgroundColor,
  borderRadius,
  padding,
  marginLeft,
  marginRight,
  marginBottom,
  marginTop,
  justifyContent,
  width,
  maxWidth,
  flexDirection,
  alignItems,
}: ShadowContainerProps) => {
  return (
    <ParentContainer paddingHorizontal={paddingHorizontal} width={width}>
      <ChildContainer
        softShadow={softShadow}
        backgroundColor={backgroundColor}
        borderRadius={borderRadius}
        padding={padding}
        marginLeft={marginLeft}
        marginRight={marginRight}
        marginBottom={marginBottom}
        marginTop={marginTop}
        justifyContent={justifyContent}
        width={width}
        maxWidth={maxWidth}
        flexDirection={flexDirection}
        alignItems={alignItems}
      >
        {children}
      </ChildContainer>
    </ParentContainer>
  );
};

const ParentContainer = styled.View<ShadowContainerProps>`
  ${({ paddingHorizontal }: { paddingHorizontal?: string }) =>
    paddingHorizontal &&
    css`
      padding-horizontal: ${paddingHorizontal};
    `}
  align-items: center;
  width: ${({ theme, width }: { theme: DefaultTheme; width?: string }) =>
    width || (!theme.isMobile ? "576px" : "100%")};
`;

const ChildContainer = styled(View)<ShadowContainerProps>`
  ${({ flexDirection }: { flexDirection?: string }) =>
    flexDirection &&
    css`
      flex-direction: row;
    `}
  background-color: ${({
    theme,
    backgroundColor,
  }: {
    theme: DefaultTheme;
    backgroundColor?: string;
  }) => backgroundColor || theme["core-01"]};
  align-items: ${({ alignItems }: { alignItems?: string }) =>
    alignItems || "flex-start"};
  border-radius: ${({ borderRadius }: { borderRadius?: string }) =>
    borderRadius || "10px"};
  padding: ${({ padding }: { padding?: string }) => padding || "16px"};
  margin-left: ${({ marginLeft }: { marginLeft?: string }) =>
    marginLeft || "5px"};
  margin-right: ${({ marginRight }: { marginRight?: string }) =>
    marginRight || "5px"};
  margin-bottom: ${({ marginBottom }: { marginBottom?: string }) =>
    marginBottom || "10px"};
  margin-top: ${({ marginTop }: { marginTop?: string }) => marginTop || "10px"};
  justify-content: ${({ justifyContent }: { justifyContent?: string }) =>
    justifyContent || "flex-start"};
  width: ${({ theme, width }: { theme: DefaultTheme; width?: string }) =>
    width || (!theme.isMobile ? "576px" : "100%")};
  max-width: ${({
    theme,
    maxWidth,
  }: {
    theme: DefaultTheme;
    maxWidth?: string;
  }) => maxWidth || (!theme.isMobile ? "576px" : "100%")};
`;

export default ShadowContainer;
